import { Directive, OnInit, OnDestroy, Input, NgModuleRef, Injector, Inject, NgModuleFactory, NgModuleFactoryLoader, Type , ViewContainerRef} from '@angular/core';
import { DynamicFormService } from '../services/dynamic-form.service';

type ModuleWithRoot = Type<any> & {rootComponent: Type<any>};

@Directive({
  selector: '[appModuleLoad]'
})
export class ModuleLoadDirective implements OnInit, OnDestroy {
  @Input('appModuleLoad') moduleName: any;
  private ngModuleRef: NgModuleRef<any>;
 
  constructor(
    private viewContainerRef: ViewContainerRef,
    private injector: Injector,
    private ngModuleFactoryLoader: NgModuleFactoryLoader,
    public dynamicFormService: DynamicFormService
  ) {}
 
  ngOnInit() { 
    this.dynamicFormService.isLoadingForm = true;

    // Validar que moduleName existe
    if (!this.moduleName) {
      console.error('ModuleLoadDirective: moduleName is null or undefined');
      this.dynamicFormService.isLoadingForm = false;
      return;
    }

    this.dynamicFormService.getByModuleName(this.moduleName)
    .then((data:any)=>{
        // Validar que data existe y tiene ModuleScripts
        if (!data || !data.ModuleScripts) {
          console.error('ModuleLoadDirective: Invalid module data for moduleName:', this.moduleName, 'Data received:', data);
          this.dynamicFormService.isLoadingForm = false;
          return;
        }

        this.ngModuleFactoryLoader
        .load(data.ModuleScripts)
        .then((moduleFactory: NgModuleFactory<any>) => {
          this.dynamicFormService.isLoadingForm = false;

          this.ngModuleRef = moduleFactory.create(this.injector);
          const rootComponent = (moduleFactory.moduleType as ModuleWithRoot).rootComponent;
      
          const factory = this.ngModuleRef.componentFactoryResolver.resolveComponentFactory(
            rootComponent
          );
      
          this.viewContainerRef.createComponent(factory);
        })
        .catch((err) => {
          console.error('ModuleLoadDirective: Error loading module factory:', err);
          this.dynamicFormService.isLoadingForm = false;
        });
    })
    .catch((err) => {
      console.error('ModuleLoadDirective: Error getting module by name:', this.moduleName, err);
      this.dynamicFormService.isLoadingForm = false;
    });
  }
 
  ngOnDestroy() {
    this.ngModuleRef && this.ngModuleRef.destroy();
  }
}